import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=5556e52a"
import script from "./empty.vue?vue&type=script&setup=true&lang=ts"
export * from "./empty.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports